(() => {
  const initialize = (root = document) => {
    root.querySelectorAll("[data-mobile-menu]").forEach((menu) => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = "true";
      menu.addEventListener("click", (event) => {
        if (event.target.closest("a")) menu.open = false;
      });
      menu.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && menu.open) {
          menu.open = false;
          menu.querySelector("summary").focus();
        }
      });
      document.addEventListener("click", (event) => {
        if (menu.open && !menu.contains(event.target)) menu.open = false;
      });
    });
    root.querySelectorAll("[data-monarch-calculator]").forEach((calc) => {
      if (calc.dataset.ready) return;
      calc.dataset.ready = "true";
      const rate = calc.querySelector("[data-calc-rate]");
      const sessions = calc.querySelector("[data-calc-sessions]");
      const tier = calc.querySelector("[data-calc-tier]");
      const money = (value) =>
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 0,
        }).format(value);
      const set = (name, value) => {
        calc.querySelector(`[data-calc-${name}]`).textContent = value;
      };
      const update = () => {
        const rent = Number(tier.value);
        const gross = Number(rate.value) * Number(sessions.value) * 4.33;
        const net = gross - rent;
        const difference = net - gross / 2;
        set("rate-output", money(Number(rate.value)));
        set("sessions-output", sessions.value);
        set("gross", money(gross));
        set("rent", money(rent));
        set("net", money(net));
        set("split", money(gross / 2));
        set("difference", (difference > 0 ? "+" : "") + money(difference));
      };
      calc.addEventListener("input", update);
      calc.addEventListener("change", update);
      update();
    });
  };
  initialize();
  document.addEventListener("shopify:section:load", (event) =>
    initialize(event.target),
  );
  let cartRefresh = 0;
  document.addEventListener("monarch:cart-change", async () => {
    const link = document.querySelector("[data-cart-count-link]");
    if (!link) return;
    const request = ++cartRefresh;
    try {
      const response = await fetch(link.dataset.cartUrl, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (request !== cartRefresh || !Number.isInteger(cart.item_count)) return;
      document.querySelectorAll("[data-cart-count]").forEach((count) => {
        count.textContent = String(cart.item_count);
      });
    } catch {
      /* The bag page remains the source of truth if refresh fails. */
    }
  });
})();
